function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_957",
  "data-name": "Group 957",
  transform: "translate(-22.422 -218.369)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_302",
  "data-name": "Path 302",
  d: "M-570.744,3527.323l8.726-10.494-503.787-.4,6.2,9.713s389.883.831,488.862,1.183",
  transform: "translate(1117.573 -3135.765)",
  fill: "#f8f9fa",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_912",
  "data-name": "Group 912",
  transform: "translate(145.918 218.869)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_305",
  "data-name": "Path 305",
  d: "M-1012.072,3335.731q-1.85-4.34-3.306-8.834a8.027,8.027,0,0,0-6.242,4.637A40.3,40.3,0,0,0-1012.072,3335.731Z",
  transform: "translate(1021.62 -3326.898)",
  fill: "#fcc419",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_306",
  "data-name": "Path 306",
  d: "M-1009.1,3335.976q3.118-3.542,5.91-7.352a8.026,8.026,0,0,1,4.473,6.361A40.281,40.281,0,0,1-1009.1,3335.976Z",
  transform: "translate(1018.614 -3327.312)",
  fill: "#fcc419",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_307",
  "data-name": "Path 307",
  d: "M-614.378,3393.187a3.087,3.087,0,0,1,1.065.643,3.213,3.213,0,0,1,.981,1.927.474.474,0,0,1-.018.242.508.508,0,0,1-.331.231c-1.6.546-3.224.8-4.854,1.2-.766.189-1.528.363-2.318.477-.293.042-2.19.448-2.351.241a21.451,21.451,0,0,1-2.976-5.16,8.121,8.121,0,0,1,4.343-2.7,16.74,16.74,0,0,1-.786,7,31.372,31.372,0,0,1,6.442-4.1A1.044,1.044,0,0,1-614.378,3393.187Z",
  transform: "translate(1034.403 -3136.914)",
  fill: "#fcc419",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_308",
  "data-name": "Path 308",
  d: "M-913.863,3694.78a10.19,10.19,0,0,1,7.036,2.3c-.57.614-11.84,12.087-12.33,12a43.085,43.085,0,0,1-11.337-3.759,16.281,16.281,0,0,1,2.9-9.833,33.556,33.556,0,0,1,8.157,11.533,66.824,66.824,0,0,1,2.863-11.708A9.67,9.67,0,0,1-913.863,3694.78Z",
  transform: "translate(1129.84 -3224.284)",
  fill: "#fcc419",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_337",
  "data-name": "Path 337",
  d: "M-828.09,3382.313a2.479,2.479,0,0,0-2.192,2.171,2.774,2.774,0,0,0,1.58,2.713,3.151,3.151,0,0,0,3.164-.383,3.355,3.355,0,0,0,1.265-2.1,2.857,2.857,0,0,0-.875-2.614,2.2,2.2,0,0,0-2.661-.16",
  transform: "translate(1108.32 -3103.65)",
  fill: "#20c997",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_338",
  "data-name": "Path 338",
  d: "M-614.246,3682.229a3.173,3.173,0,0,0-3.016,2.452,3.173,3.173,0,0,0,1.8,3.447,4.509,4.509,0,0,0,1.925.3,2.889,2.889,0,0,0,1.761-.517,2.6,2.6,0,0,0,.776-1.283,3.858,3.858,0,0,0-.462-3.428,2.592,2.592,0,0,0-3.192-.806",
  transform: "translate(1031.896 -3229.415)",
  fill: "#fcc419",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_302-2",
  "data-name": "Path 302",
  d: "M-833.827,3540.48c-12.668,4.7-35.064,15.618-44.344,25.4q-2.371,2.5-4.546,5.177c-1.275,1.573-3.021,3.329-3.443,5.369.37.152.765-.131,1.065-.4.6-.532,1.174-1.123,1.8-1.624,10.362-8.3,23.483-17.215,36.221-21.1,14.829-4.522,45.079-8.245,60.428-10.431",
  transform: "translate(1201.716 -3152.082)",
  fill: "#f8f9fa",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_333",
  "data-name": "Path 333",
  d: "M-789.886,3595.64a43.356,43.356,0,0,1-1.627-6.14c-.041-.215-.052-.492.142-.593a.525.525,0,0,1,.4.024,43.908,43.908,0,0,1,5.242,2.189c3.1,1.54,5.692,4.562,2.946,7.865a3.535,3.535,0,0,1-3.419.964C-788.295,3599.535-789.255,3597.463-789.886,3595.64Z",
  transform: "translate(1093.104 -3177.075)",
  fill: "#20c997",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_334",
  "data-name": "Path 334",
  d: "M-783.136,3622.595a13.81,13.81,0,0,0-1.02,3.9,6.085,6.085,0,0,1-1.891,3.494c-.129.13.756,0,.787-.007a9.642,9.642,0,0,0,1.238-.342,15.309,15.309,0,0,0,2.547-1.132,10.528,10.528,0,0,0,2.73-1.943,4.541,4.541,0,0,0,1.332-3.005C-777.391,3620-781.692,3619.87-783.136,3622.595Z",
  transform: "translate(1090.842 -3190.213)",
  fill: "#20c997",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_335",
  "data-name": "Path 335",
  d: "M-751.681,3612.872a4.08,4.08,0,0,0,.817,2.117,12.174,12.174,0,0,0,2.668,2.239,5.409,5.409,0,0,1,2.187,2.646c.6,2.063,1.548-.672,1.754-1.381a14.133,14.133,0,0,0,.894-5.591,6,6,0,0,0-.787-2.6,4.238,4.238,0,0,0-4.649-1.77A4.108,4.108,0,0,0-751.681,3612.872Z",
  transform: "translate(1076.657 -3185.129)",
  fill: "#20c997",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_928",
  "data-name": "Group 928",
  transform: "translate(22.422 321.451)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_376",
  "data-name": "Path 376",
  d: "M-3150.713-574.729a3.73,3.73,0,0,1,1.244.261c6.717,4.265,14.353,7.239,19.446,13.791,1.038.17,2.174.153,2.651,1.391.631,1.782-.756,2.91-1.4,4.281-3.555,7.594-3.908,15.094.817,22.359,1.077,1.655,2.338,3.475,4.655,3.244,2.221-.223,2.615-2.323,3.414-3.97.757-1.56.706-3.84,3.258-3.947a4.28,4.28,0,0,1,2.635,2.813,14.942,14.942,0,0,1-2.843,8.68c-1.805,2.636-.852,3.986,1.879,5.041,2.008.775,4.69.2,5.921,2.7a1.7,1.7,0,0,1-1.286,1.947,27.138,27.138,0,0,1-16.15-7.839c-3.047-2.961-2.9-2.512-5.4-.223a19.422,19.422,0,0,1-13.468,5.483l-.637,0c-1.2-.267-1.889-.892-1.546-2.229,1.606-2.252,4.352-1.816,6.535-2.695,6.373-2.567,7.225-4.176,5.107-10.54a29.785,29.785,0,0,1,.3-20.068c1.069-2.954,1.552-5.8-1.639-7.828-.151.04-.307.045-.464.082a8.366,8.366,0,0,1-.974.311,3.536,3.536,0,0,1-1.742.023,4.5,4.5,0,0,1-2.51-2.186c-3.2-4.632-7.4-7.3-13.233-7.165-1.73.041-3.89.184-4.294-2.428C-3157.487-576.1-3153.924-574.082-3150.713-574.729Z",
  transform: "translate(3627.57 577.994)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_377",
  "data-name": "Path 377",
  d: "M-3620.4-512.986c-2.917-1.075-4.93-3.322-6.987-5.48-1.1-1.152-2.021-1.329-3.207-.143a21.146,21.146,0,0,1-13.178,6.384,1.846,1.846,0,0,0-1.564,1.16c-1.517,2.831-3.974,2.954-6.018.405-1.3-1.619-2.441-1.639-3.311.39-.639,1.488-1.259,1.374-2.543,1.206-2.036-.266-4.062-.292-5.272-2.327-.61-1.536.244-2.49,1.326-3.352,2.048-1.541,4.25-1.44,6.783-1.458,5.565-.039,11.381.908,16.626-2.16,3.729-2.181,4.4-3.688,2.82-7.669-.846-2.136-1.708-4.237-1.31-6.613a4.165,4.165,0,0,1,2.178-2.3c2.544-.226,2.916,1.878,3.556,3.51a20.989,20.989,0,0,0,4.18,7.337c2.493,2.553,4.207,2.3,5.952-.848.927-1.669,1.156-3.952,3.738-4.124a2.622,2.622,0,0,1,1.926,1.47c1.338,3.489-.329,6.387-2.188,9.012a11.808,11.808,0,0,0-2,5C-3619.247-513.016-3619.677-512.626-3620.4-512.986Z",
  transform: "translate(3733.266 569.598)",
  fill: "#303030"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_378",
  "data-name": "Path 378",
  d: "M-3082.223-572.454c6.213,3.675,12.87,6.618,18,12a28.638,28.638,0,0,1,7.869,17.179c.888,8.361-1.881,15.407-8.62,20.694a2.517,2.517,0,0,1-1.727-.537,20.49,20.49,0,0,1-9.369-14.036,5.009,5.009,0,0,1,2.464-3.866c2.859-.34,2.995,2.052,3.747,3.792,1.095,2.531,1.394,6.406,4.971,6,3.492-.4,3.946-4.234,4.387-7.116,1.033-6.762-1.3-12.671-5.492-17.874a18.88,18.88,0,0,0-4.147-4.253,5.68,5.68,0,0,0-1.555.139,3.2,3.2,0,0,1-1.715-.035c-3.5-2.947-6.165-6.838-10.274-9.129a1.821,1.821,0,0,1-.609-1.9C-3083.95-572.422-3082.957-572.183-3082.223-572.454Z",
  transform: "translate(3611.555 577.487)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_379",
  "data-name": "Path 379",
  d: "M-3373.512-512.9c-1.976-.955-3.366-2.618-4.863-4.127-1.156-1.165-2.153-1.154-3.272-.035a20.749,20.749,0,0,1-12.762,6.337c-.706.074-1.537.215-1.633,1.085-.211,1.941-.929,2.709-3.086,2.269-1.431-.292-2.56-.244-3.27-1.915a1.428,1.428,0,0,0-2.668-.026c-.681,2.465-2.065,1.771-3.826,1.841a3.916,3.916,0,0,1-4.05-2.148c-.677-1.457.065-2.47,1.054-3.406,2.053-1.57,4.419-1.277,6.82-1.58,5.394-.679,11.124.83,16.193-2.2,3.8-2.272,4.346-3.595,2.837-7.716-.885-2.416-1.921-4.777-1.818-7.437a4.407,4.407,0,0,1,2.6-2.919c1.627-.107,2.22,1.01,2.609,2.291a31.643,31.643,0,0,0,9.19,14.092,18.08,18.08,0,0,1,.864,2.271c.271.939.965,1.8.525,2.871C-3372.437-512.851-3372.833-512.43-3373.512-512.9Z",
  transform: "translate(3680.764 569.582)",
  fill: "#404040"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_380",
  "data-name": "Path 380",
  d: "M-3475.375-509.4a1.072,1.072,0,0,1-.738-.154,1.615,1.615,0,0,1,.483-1.8,36.562,36.562,0,0,1,10.967-2.517c6.935-.638,14.7.93,20.24-5.3a7.368,7.368,0,0,0,1.211-2.81,19.065,19.065,0,0,0,5.487-12.716c.053-1.432.315-2.886,1.84-3.646a2.668,2.668,0,0,1,1.449-.062c1.939.7,2.3,2.35,2.365,4.1.217,6.024-1.346,11.438-5.577,15.907a8.919,8.919,0,0,1-2.415,1.593c-1.2-.291-1.829.57-2.546,1.251a18.97,18.97,0,0,1-11.427,5.413c-1,.1-1.778.2-2.284,1.443-1.02,2.5-3.847,2.773-5.714.744-1.788-1.943-2.368-1.992-3.562.073-.461.8-.723,1.761-1.742,1.257-1.487-.735-3.973,1.251-4.6-1.7C-3472.751-509.738-3474.423-508.42-3475.375-509.4Z",
  transform: "translate(3694.026 570.337)",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_381",
  "data-name": "Path 381",
  d: "M-3688.975-518.978c-1.455.388-2.37,1.544-3.466,2.44a19.567,19.567,0,0,1-8.838,4.114c-1.871.358-3.881.048-4.258,2.963-.175,1.353-4.041.874-5.342-.655-1.821-2.138-2.149-2.125-3.7.37-.3.476-.458,1.293-1.086.965-1.907-1-4.88.746-5.981-2.32-.055-.153-.523-.157-.8-.231-.571-1.921.594-2.844,2.056-3.6,2.161-1.21,4.434-.869,6.8-1,4.571-.257,9.3.534,13.787-1.079,2.449-.88,4.249-2.238,4.537-5.021a3.424,3.424,0,0,1,1.123-1.443c4.252-1.974,6.977-5.094,7.428-9.925.351-2.608.527-5.338,4.069-5.635,2.89,2.688,1.935,6.076,1.292,9.145a19.733,19.733,0,0,1-5.6,10.334A1.873,1.873,0,0,1-3688.975-518.978Z",
  transform: "translate(3745.874 570.454)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_382",
  "data-name": "Path 382",
  d: "M-3565.587-517.035c-1.113.05-1.753.885-2.52,1.513a20.438,20.438,0,0,1-10.115,4.4c-.926.139-2.252-.272-2.532,1.034-.328,1.528-.517,2.892-2.62,2.373-1.263-.311-2.626.264-3.506-1.625-.857-1.837-2.469-1.659-3.323.245-.5,1.122-.76,1.521-2.064,1.322-3.237-.495-3.25-.4-5.937-2.474-.571-1.921.595-2.843,2.057-3.6,2.161-1.211,4.434-.868,6.8-1,4.57-.257,9.3.534,13.787-1.079,2.448-.88,4.248-2.238,4.537-5.02a3.42,3.42,0,0,1,1.123-1.444c4.247-1.972,6.974-5.088,7.427-9.916.367-2.589.488-5.348,4.038-5.661,2.843,2.336,2.036,5.553,1.5,8.319a20.59,20.59,0,0,1-6.594,12.156A2,2,0,0,1-3565.587-517.035Z",
  transform: "translate(3719.727 570.229)",
  fill: "#2d2d2d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_383",
  "data-name": "Path 383",
  d: "M-3519.049-572.5c5.551,3.727,12,6.2,16.316,11.654,1.166,1.474,2.233,1.305,3.531-.013,1.792-1.82,3.438-3.872,5.952-4.82,1.528.088,2.224,1.206,2.91,2.339.647,2.444-.46,4.177-2.757,4.373-4.55.39-6.211,3.6-7.651,7.078a22.033,22.033,0,0,0-.652,14.7c.486,1.751,1.479,3.459.782,5.4a7.135,7.135,0,0,1-1.676,1.841c-2.69.7-3.472-1.186-4.219-3.118a29.3,29.3,0,0,1-.586-18.852c.527-1.908,1.6-3.78.928-5.8-.52-1.57-1.06-3.423-3.45-2.906a4.15,4.15,0,0,1-1.821.246c-3.674-3.076-6.944-6.5-9-10.92A1.907,1.907,0,0,1-3519.049-572.5Z",
  transform: "translate(3703.333 577.497)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_384",
  "data-name": "Path 384",
  d: "M-3190.848-514.266c-3.644,3.585-7.822,6.141-13.012,6.749-1,.117-2.072.167-2.153,1.544-.121,2.057-1.311,2.1-2.966,1.814-1.206-.211-2.27.166-3.026-1.5-.79-1.743-2.214-1.668-3.211-.222-.5.729-.382,2.52-1.691,1.794-1.62-.9-3.859,1.047-4.913-1.22-.555-1.192-1.594-.988-2.5-1.248-.35-2.323,1.165-3.155,2.98-3.747,3.89-2.725,8.437-1.165,12.48-1.193a25.764,25.764,0,0,0,14.8-4.6c1.394-.772,1.53-2.148,1.673-3.525,1.4-2.294,3.229-4.308,4.25-6.849a2.806,2.806,0,0,1,2.94-2.008,4.081,4.081,0,0,1,2.4,2.534,13.952,13.952,0,0,1-5.486,10.969C-3189.04-514.385-3190.1-514.9-3190.848-514.266Z",
  transform: "translate(3641.025 568.234)",
  fill: "#363636"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_385",
  "data-name": "Path 385",
  d: "M-3629.316-542.884a6.456,6.456,0,0,0-.959,2.771c-2.556.1-2.556-1.848-2.711-3.524a25.14,25.14,0,0,1,2.129-12.972c1.957-4.313,1.457-5.094-3.011-5.551-.576-.059-1.307,0-1.617-.429-2.679-3.734-6.688-6.5-8.113-11.152a1.81,1.81,0,0,1,1.452-1.068c5.337,3.533,11.509,5.894,15.633,11.126,1.193,1.514,2.223,1.292,3.5-.01,1.49-1.521,2.946-3.146,4.99-4a3.462,3.462,0,0,1,3.652,2.233c.235,3.307-.926,5.35-4.62,4.691-1.619-.288-2.316.648-3.168,1.639a20.911,20.911,0,0,0-5.041,12.056C-3627.348-545.45-3627.049-543.488-3629.316-542.884Z",
  transform: "translate(3729.25 577.983)",
  fill: "#303030"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_386",
  "data-name": "Path 386",
  d: "M-3314.021-515.676c-1.737.469-2.755,1.987-4.2,2.894a19.412,19.412,0,0,1-7.953,3.007c-1.465.183-2.766.152-2.949,2.21-.174,1.975-1.812,1.19-3.025,1.24-1.7.071-2.845-.289-2.571-2.32a3,3,0,0,1-.163-2.549,6.466,6.466,0,0,1,1.291-2.228c1.583-1.143,3.3-.475,4.987-.374q7.127.427,9.179-5.836a3.433,3.433,0,0,1,1.128-1.442,12.242,12.242,0,0,0,7.521-10.588c.456-2.22,1.181-4.174,3.987-4.1,2.76,2.6,1.853,5.784,1.159,8.767a28,28,0,0,1-4.687,9.544C-3311.31-516.36-3312.3-515.265-3314.021-515.676Z",
  transform: "translate(3664.325 569.767)",
  fill: "#3d3d3d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_387",
  "data-name": "Path 387",
  d: "M-3182.067-534.5l-.907-2.742c-2.268-.6-2-2.552-2.094-4.182a25.265,25.265,0,0,0-3.87-12.1c-1.645-2.645-3.228-5.476-7.263-4.688-1.568.307-2.581-1-3.367-2.242-2.512-3.959-5.582-7.2-10.29-8.542-1.334-.379-2.271-1.248-1.7-2.88,1.035-1.11,2.432-.2,3.585-.644a4.559,4.559,0,0,1,2.731,1.017c4.6,3.476,10.086,5.6,14.473,9.4a12.751,12.751,0,0,1,3.759,1.659c6.5,6.26,8.349,14.082,7.61,22.747C-3179.537-536.1-3179.9-534.5-3182.067-534.5Z",
  transform: "translate(3638.365 577.502)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_388",
  "data-name": "Path 388",
  d: "M-3068.689-510.7l1.053.977a16.9,16.9,0,0,1-10.429,5.326c-1.331.216-2.709.036-3.2,2.071s-4.13,2.137-5.558.351c-1.762-2.2-2.457-2.276-3.646.092-.6,1.2-1.115,1.458-2.238,1.033a7.126,7.126,0,0,0-2.961-.129c-1.273.063-1.124-1.008-1.291-1.8l.938-1.675c-.164-2.054.945-3.84,2.779-3.456,4.154.869,8-1.495,12.128-.551,2.711.62,5.346-.405,7.743-1.778C-3071.863-511.107-3070.4-512.06-3068.689-510.7Z",
  transform: "translate(3614.213 564.635)",
  fill: "#2f2f2f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_389",
  "data-name": "Path 389",
  d: "M-3261.249-565.007c3.094,1.081,5.268,3.385,7.433,5.669,2.523,2.662,2.556,3.435,5.544.172,1.721-1.879,3.46-3.834,5.945-4.813a3.8,3.8,0,0,1,2.892,2.356c.549,2.187-.384,3.967-2.387,4.332-7.648,1.394-8.418,7.515-9.567,13.4-.324,1.657.028,3.44-.831,5.01a2.062,2.062,0,0,1-1.745,1.071c-2.359-.662-3.11-2.452-3.273-4.65-.372-3.018.418-5.863,1.177-8.756,1.147-4.376-.115-5.836-4.48-5.611-2.871.148-4.532-2.52-4.21-6.763C-3263.912-564.882-3262.578-564.94-3261.249-565.007Z",
  transform: "translate(3649.531 575.92)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_390",
  "data-name": "Path 390",
  d: "M-3269.713-567.11l-2.66,1.817c-1.207.8-2.073.112-3.064-.566-9.341-6.387-15.375-5.948-24.082,1.7-.862.757-1.681,1.577-2.956,1.55-1.771-.466-2.775-1.488-2.484-3.441a36.758,36.758,0,0,0,4.629-3.645c6.8-6.322,15.681-7.013,23.466-1.957C-3274.5-570.115-3272.1-568.623-3269.713-567.11Z",
  transform: "translate(3657.995 578.023)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_391",
  "data-name": "Path 391",
  d: "M-3253.24-537.649c1.057,1.56.527,3.63,1.657,5.167,1.772.005,2.479,1.164,2.894,2.655a17.055,17.055,0,0,0,2.584,5.4c1.161,1.619,2.191,3.615,4.6,3.3,2.2-.286,2.609-2.371,3.441-4.019.841-1.663.663-4.194,3.445-4.347a4.351,4.351,0,0,1,2.586,2.8,14.531,14.531,0,0,1-2.476,8.354,20.493,20.493,0,0,0-2.6,6.109c-.446.486-.931.846-1.626.471-4-1.5-6.385-4.977-9.416-7.665-.75-.625-1.75-.814-2.507-1.432-3.581-3.57-4.58-8.068-4.542-12.892C-3255.186-535.292-3255.075-536.942-3253.24-537.649Z",
  transform: "translate(3647.513 570.163)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_392",
  "data-name": "Path 392",
  d: "M-3678.519-545.827c-1.33,2.112-.246,4.781-1.592,6.889-2.265-.556-2.107-2.489-2.1-4.1.031-7.89-3.408-14.087-9.094-19.2,0,.05-.415.059-.414.109a6.067,6.067,0,0,1-.867.451,2.933,2.933,0,0,1-1.679.181c-3.017-2.828-6.582-5.26-7.236-9.832a2.091,2.091,0,0,1,1.5-1.115c4.241,2.737,8.917,4.81,12.664,8.3a2.6,2.6,0,0,1,2.041.279c4.978,3.392,6.852,8.642,8.358,14.083C-3676.492-548.152-3676.671-546.613-3678.519-545.827Z",
  transform: "translate(3741.435 577.484)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_393",
  "data-name": "Path 393",
  d: "M-3306.015-542.783l-1.581,5.168c-2.065-.474-2.052-2.212-2.114-3.741-.34-8.135-4.644-14.159-10.23-19.52a9.565,9.565,0,0,0-2.325-.387,5.564,5.564,0,0,1-1.817-.156c-2.215-2.347-5.7-3.755-5.744-7.721a1.97,1.97,0,0,1,1.459-1.1c4.249,2.935,9.338,4.594,12.935,8.518,1.323.722,3.115.39,4.139,1.81a27.644,27.644,0,0,1,6.679,12.425C-3304.146-545.636-3303.781-543.823-3306.015-542.783Z",
  transform: "translate(3663.218 577.021)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_394",
  "data-name": "Path 394",
  d: "M-3737.179-514.232c-7.315-4.234-12.387-10.134-13.875-18.693a4.753,4.753,0,0,1,.11-3.792c2.99-.681,3.149,1.825,3.686,3.539a18.82,18.82,0,0,0,4.154,7.788c2.487,2.566,4.221,2.314,5.965-.8.93-1.661,1.142-3.95,3.719-4.135a2.564,2.564,0,0,1,1.931,1.468c1.379,3.5-.318,6.394-2.175,9.022a12.087,12.087,0,0,0-2,5.015C-3736.02-514.25-3736.457-513.867-3737.179-514.232Z",
  transform: "translate(3751.934 569.991)",
  fill: "#3d3d3d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_395",
  "data-name": "Path 395",
  d: "M-3378.05-540.6a9.1,9.1,0,0,0-.975,3.638c-2.153.023-2.46-1.565-2.635-3.144a17.014,17.014,0,0,1,.664-8.371c1.674-4.114,2.6-8.227,1.416-12.627a2.091,2.091,0,0,1,1.647-1.162c4.275,3.611,4.266,3.6,8.557-.015.753-.635,1.614-1.142,2.425-1.709,1.28.168,2.674.04,3.517,1.345,1.012,2.6.158,5-2.4,5.307-6.061.737-7.4,5.334-9.029,9.822a44.439,44.439,0,0,0-1.277,4.922A2.248,2.248,0,0,1-3378.05-540.6Z",
  transform: "translate(3674.171 575.707)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_396",
  "data-name": "Path 396",
  d: "M-3484.357-563.5q-.822-1.3-1.645-2.6c1.407-1.2,2.827-2.388,4.219-3.608,6.621-5.807,14.929-6.382,22.5-1.544a1.557,1.557,0,0,1-.542,1.789c-1.323,1.053-2.671.466-4.07.137a17.1,17.1,0,0,0-15.638,3.678C-3480.933-564.484-3482.158-562.892-3484.357-563.5Z",
  transform: "translate(3696.084 577.921)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_397",
  "data-name": "Path 397",
  d: "M-3273.715-503.569c.176,1.137.472,2.778-.9,2.853-1.5.082-3.282.677-4.695-1.045-1.693-2.065-1.869-1.921-3.537.13-.9,1.112-5.3,1.412-6.268.094a3.945,3.945,0,0,0-2.822-1.57c-.394-2.518,1.4-3.217,3.227-3.886,5.075-1.342,10.13-2.141,15.028.662A3.6,3.6,0,0,1-3273.715-503.569Z",
  transform: "translate(3655.257 563.969)",
  fill: "#3d3d3d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_398",
  "data-name": "Path 398",
  d: "M-3648.946-575.656l-.985.983c-.92,1.585-2.362,1.326-3.768,1.011a17.3,17.3,0,0,0-16.811,4.811c-1,.973-2.027,2.061-3.676,1.8-1.7-.61-1.987-1.851-1.528-3.423,1.318-1.08,2.717-2.075,3.939-3.254C-3666.769-578.557-3657.079-581.351-3648.946-575.656Z",
  transform: "translate(3736.049 578.829)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_399",
  "data-name": "Path 399",
  d: "M-3707.156-573.5l-.871.8c-1.048,1.018-2.3.94-3.589.673-7.409-1.532-14.143-.718-19.335,5.535a2.529,2.529,0,0,1-1.936.764c-1.809-.411-2.817-1.431-2.567-3.4a23.708,23.708,0,0,0,4.368-3.415C-3724.844-578.51-3714.222-579.409-3707.156-573.5Z",
  transform: "translate(3748.588 578.55)",
  fill: "#303030"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_400",
  "data-name": "Path 400",
  d: "M-3360.269-564.386l-2.706-1.867a22,22,0,0,0,4.615-3.6c5.834-5.468,15.756-6.913,23.018-1.327l-.936.822a2.413,2.413,0,0,1-2.955,1.037c-6.828-1.676-12.941-.383-18.234,4.362A2.952,2.952,0,0,1-3360.269-564.386Z",
  transform: "translate(3670.194 577.966)",
  fill: "#373737"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_401",
  "data-name": "Path 401",
  d: "M-3608.921-565.65q-1.141-1.193-2.284-2.384a23.6,23.6,0,0,0,4.052-3.126c6.491-6.421,17.282-7.093,24.243-1.266a1.448,1.448,0,0,1-.69,1.692c-2.458.929-4.721-.443-7.07-.7-5.542-.606-10.466.422-14.479,4.469A3.644,3.644,0,0,1-3608.921-565.65Z",
  transform: "translate(3722.433 578.321)",
  fill: "#303030"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_402",
  "data-name": "Path 402",
  d: "M-3088.592-572.937l-1.937.941c-.7,1.552-2.119,1.845-3.561,1.861a17.972,17.972,0,0,0-14.493,6.932,2.8,2.8,0,0,1-1.448.847,5.123,5.123,0,0,1-3.082-.659,4.028,4.028,0,0,1-1.058-.617,1.475,1.475,0,0,1-.266-1.671,76.558,76.558,0,0,0,6.4-4.767C-3102.221-574.906-3095.7-576.227-3088.592-572.937Z",
  transform: "translate(3617.923 577.971)",
  fill: "#373737"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_403",
  "data-name": "Path 403",
  d: "M-3525.6-573.246l-1.085.992c-.938,1.575-2.5,1.2-3.859,1.1-6.388-.46-12.279.452-16.817,5.572a2.706,2.706,0,0,1-2.34.86c-1.744-.5-2.2-1.653-1.667-3.3,1.088-.923,2.245-1.776,3.254-2.779C-3542.06-576.826-3531.862-577.661-3525.6-573.246Z",
  transform: "translate(3709.884 578.241)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_404",
  "data-name": "Path 404",
  d: "M-3453.332-569.482l.91-.906c4.006,2.65,8.539,4.451,12.229,7.6a2.161,2.161,0,0,0,2.328.575,11.49,11.49,0,0,1,2.87,1.8,30.909,30.909,0,0,1,6.226,11.082c.58,1.831.935,3.671-1.288,4.777l-1.023.025c-2.727.345-2.922-2.008-3.379-3.574-1.5-5.131-5.431-8.57-8.388-12.681-.5-.7-1.518-.733-2.305-1.045-.96-.349-2-.194-2.979-.472C-3450.059-564.547-3453.965-565.378-3453.332-569.482Z",
  transform: "translate(3689.223 577.053)",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_405",
  "data-name": "Path 405",
  d: "M-3234.672-563.445l-1.667-2.5c1.51-1.278,2.981-2.606,4.537-3.826,5.638-4.425,11.783-5.96,18.651-3.135-1.118.778-2.458.759-3.716,1.033-.136.248-.241.614-.461.694-5.738,2.107-11.47,4.218-16.515,7.8C-3234.021-563.251-3234.392-563.409-3234.672-563.445Z",
  transform: "translate(3643.544 577.882)",
  fill: "#323232"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_406",
  "data-name": "Path 406",
  d: "M-3553.285-565.893l1.643,2.494c1.647,1.627,1.034,3.25-.467,4.3-1.741,1.215-1.083,2.148-.268,3.416a26.8,26.8,0,0,1,3.111,7.843c.444,1.686.666,3.416-1.488,4.249-1.445,2.084-.292,4.793-1.659,6.894a2.678,2.678,0,0,1-1.96-2.951c.026-6.837-2.821-12.656-6.294-18.271a5.4,5.4,0,0,1,1.326-3.665C-3557.19-562.833-3555.8-565.153-3553.285-565.893Z",
  transform: "translate(3711.801 576.107)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_407",
  "data-name": "Path 407",
  d: "M-3154.817-575.032c-1.393.888-2.958.816-4.512.823-1.692.008-3.4-.089-4.96.78-.015.889-.187,1.9-1.012,2.205-3.836,1.42-6.222,4.839-9.64,6.816a17.171,17.171,0,0,1-3.191.028,3.249,3.249,0,0,1-1.195-.422,1.41,1.41,0,0,1-.49-1.687c2.661-1.845,5.14-3.93,7.7-5.892C-3166.927-576.348-3161.087-577.448-3154.817-575.032Z",
  transform: "translate(3631.674 578.298)",
  fill: "#3e3e3e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_408",
  "data-name": "Path 408",
  d: "M-3502.666-519.469q.423-.912.845-1.824c4.283.582,6.718,3.142,7.738,7.224a2.048,2.048,0,0,1-2.711,1.5c-.338-.258-.7-.494-1.011-.779-2.656-2.4-2.672-2.419-5.309-.018-3.32,3.022-6.857,5.577-11.581,5.76-1.61-1.3-4.051,1.413-5.406-1.117-.059-1.945,1.387-2.378,2.8-2.436C-3510.968-511.423-3506.714-515.244-3502.666-519.469Z",
  transform: "translate(3703.26 566.721)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_409",
  "data-name": "Path 409",
  d: "M-3384.05-564.55l-1.2,1.12c-3.772,4.174-4.486,4.25-7.565-.34-3.289-4.906-7.511-7.54-13.57-7.244-1.852.09-4.575.588-4.553-2.814,3.351-1.879,6.975-.444,10.445-.872a1.126,1.126,0,0,1,.419.043C-3394.533-571.605-3388.827-568.814-3384.05-564.55Z",
  transform: "translate(3680.288 577.986)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_410",
  "data-name": "Path 410",
  d: "M-3404.171-575.03c-1.538.985-3.266.733-4.951.76-1.831.031-3.694-.144-5.378.835-.006.282.058.668-.111.816-3.593,3.142-7,6.533-11.309,8.758-1.739-.549-2.772-1.584-2.424-3.557q3.058-2.3,6.047-4.687C-3416.873-576.447-3410.788-577.615-3404.171-575.03Z",
  transform: "translate(3683.965 578.316)",
  fill: "#3b3b3b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_411",
  "data-name": "Path 411",
  d: "M-3738.945-566.9l2.287,2.387c2.043,2.442.7,4.662-1.576,4.606-6.312-.152-7.055,4.735-8.86,8.71a16.654,16.654,0,0,0-1.089,5.011c-.16,1.412-.252,2.941-2.134,3.256a8.447,8.447,0,0,0-.882,3.673,21.925,21.925,0,0,1,2.675-18.045A27.222,27.222,0,0,1-3738.945-566.9Z",
  transform: "translate(3752.079 576.318)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_412",
  "data-name": "Path 412",
  d: "M-3490.582-514.5l1.917-1.826c2.071-4.016,4.372-7.925,5.217-12.467a2.046,2.046,0,0,1,2.184-1.669c2.187,1.052,2.969,2.9,2.979,5.195a18.048,18.048,0,0,1-2.692,8c-1.516,2.308-1.723,4.137,1.062,5.588,1.132.589,2.278,1.341,1.724,2.984l-.942.832C-3483.452-509.211-3487.6-510.849-3490.582-514.5Z",
  transform: "translate(3697.048 568.651)",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_413",
  "data-name": "Path 413",
  d: "M-3146.454-504.912c-.321,1.15.3,3.046-1.348,3.191-1.611.141-3.654.93-4.865-1.356-.895-1.69-2.239-1.635-3.187.067-.426.765-.713,1.821-1.7,1.459-1.577-.579-3.615.738-4.757-.947-.868-1.284-2.1-1.289-3.283-1.645-.485-1.109.26-1.8.856-2.542,2.968-1.119,5.651-3.439,9.187-2.234a6.9,6.9,0,0,1,4.1,1.848c1.288,1.1,2.373,2.635,4.441,2.079A4.37,4.37,0,0,0-3146.454-504.912Z",
  transform: "translate(3628.689 564.188)",
  fill: "#2b2b2b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_414",
  "data-name": "Path 414",
  d: "M-3337.336-504.86l-.945,2.023c-1.528-.268-3-.844-3.7,1.488-.383,1.27-5.165,1.358-6.194-.088-1.048-1.474-2.465-1.182-3.707-1.69-.436-1.123.345-1.75.986-2.439,2.69-.583,4.82-2.889,7.814-2.575A24.577,24.577,0,0,1-3337.336-504.86Z",
  transform: "translate(3667.887 563.959)",
  fill: "#3d3d3d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_415",
  "data-name": "Path 415",
  d: "M-3562.81-562.735a2.054,2.054,0,0,1-.167,2.568c-1.83,1.528-3.442-1.3-5.252-.241a3.115,3.115,0,0,1-1.849.1c-2.936-1.852-4.407-5.009-6.627-7.5a2.132,2.132,0,0,1,.085-2.738l.872-.815C-3571.385-568.561-3566.56-566.454-3562.81-562.735Z",
  transform: "translate(3715.269 577.257)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_416",
  "data-name": "Path 416",
  d: "M-3522.1-506.859c1.337,1.533,3.5.868,5.031,1.9-1.211.448-2.748.024-3.181,2.119-.377,1.823-3.982,2.15-5.417.711-2.609-2.618-2.612-2.618-4.3.6a3.243,3.243,0,0,1-.958-4.335c.591-.947,1.646-1.217,2.535-1.727C-3526.21-508.093-3523.835-510.217-3522.1-506.859Z",
  transform: "translate(3705.634 564.074)",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_417",
  "data-name": "Path 417",
  d: "M-3269.112-505.407l-1.011-2.2a3.589,3.589,0,0,1,2.62-2.013,21.943,21.943,0,0,0,11.049-6.26c1.305-1.369,2.9-.813,4.372-1.073l.792,1.89a22.705,22.705,0,0,0-1.851,1.709A23.555,23.555,0,0,1-3269.112-505.407Z",
  transform: "translate(3650.654 565.807)",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_418",
  "data-name": "Path 418",
  d: "M-3532.1-505.769q-.015,2.126-.03,4.253c-2.495-.006-5.145.74-6.983-1.951-.352-.515-1.587-.426-2.414-.615-.448-1.11.313-1.745.948-2.433,2.633-.4,4.745-3.209,7.8-1.714A1.9,1.9,0,0,1-3532.1-505.769Z",
  transform: "translate(3707.797 564.063)",
  fill: "#303030"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_419",
  "data-name": "Path 419",
  d: "M-3291.107-505.875c-1.2,1.159-2.99.73-4.287,1.618a24.551,24.551,0,0,1-13.012-6.772l1.772-2.656c4.559,2.534,8.928,5.488,14.281,6.234C-3291.637-507.351-3291.245-506.623-3291.107-505.875Z",
  transform: "translate(3658.71 565.12)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_420",
  "data-name": "Path 420",
  d: "M-3430.424-511.591q.4-1.062.794-2.125a85.256,85.256,0,0,1,15.545,6.837l-2.48,1.713C-3422.017-505.513-3426.5-507.948-3430.424-511.591Z",
  transform: "translate(3684.388 565.126)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_421",
  "data-name": "Path 421",
  d: "M-3680.014-514.033l.963-.979a2.552,2.552,0,0,1,2.439-.328,74.549,74.549,0,0,0,12.136,5.145c.551.176.756.81.882,1.382l-2.535,1.51C-3671.609-507.79-3676.045-510.431-3680.014-514.033Z",
  transform: "translate(3736.913 565.51)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_422",
  "data-name": "Path 422",
  d: "M-3167.106-505.85l-1.89,1c-3.768-.468-6.837-2.549-10.01-4.376-.972-.56-1.753-1.446-2.907-1.7l2.1-.885a1.84,1.84,0,0,1,2.261-.64c3.109,1.627,6.378,2.9,9.523,4.438A1.87,1.87,0,0,1-3167.106-505.85Z",
  transform: "translate(3632.091 564.898)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_423",
  "data-name": "Path 423",
  d: "M-3542.95-505.822l-1.774.868a24.18,24.18,0,0,1-12.13-6.787l1.056-1.068C-3550.788-511.818-3545.961-510.49-3542.95-505.822Z",
  transform: "translate(3710.995 564.935)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_424",
  "data-name": "Path 424",
  d: "M-3677.324-568.247l1.73,2.63c1.687,2.377.457,3.639-1.828,3.945a13.21,13.21,0,0,1-4.927-.364l-1.216-1.218C-3681.605-565.068-3679.942-567.254-3677.324-568.247Z",
  transform: "translate(3737.66 576.602)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_425",
  "data-name": "Path 425",
  d: "M-3733.39-508.556l.833-.723c3.125-1.371,8.478-.226,11.22,2.4l-3.381,1.687C-3728.038-505.209-3730.782-506.7-3733.39-508.556Z",
  transform: "translate(3748.146 564.315)",
  fill: "#303030"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_426",
  "data-name": "Path 426",
  d: "M-3597.092-505.789c-.892,1.031-2.4.818-3.38,1.685-3.317-.019-6.066-1.5-8.66-3.371l.813-.707C-3605.2-509.565-3599.844-508.424-3597.092-505.789Z",
  transform: "translate(3721.996 564.086)",
  fill: "#2d2d2d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_427",
  "data-name": "Path 427",
  d: "M-3309.169-557.717l-2.425-2.62c2.271-.289,3.187-2.714,5.25-3.33l2.432,2.446c1.035,3.084.286,4.324-2.479,3.818A5.764,5.764,0,0,0-3309.169-557.717Z",
  transform: "translate(3659.381 575.638)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_428",
  "data-name": "Path 428",
  d: "M-3234.346-505.214l.909-.748c3.079-1.434,8.448-.306,11.23,2.358-1.156,1.182-2.933.783-4.211,1.653A15.3,15.3,0,0,1-3234.346-505.214Z",
  transform: "translate(3643.125 563.626)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_429",
  "data-name": "Path 429",
  d: "M-3429.462-565.026a9.588,9.588,0,0,1,2.565,2.641c1.985,2.838.426,3.9-2.218,4.012-1.216.052-2.472-.764-3.617.293a4.329,4.329,0,0,1-.992-3A13.03,13.03,0,0,1-3429.462-565.026Z",
  transform: "translate(3685.082 575.924)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_430",
  "data-name": "Path 430",
  d: "M-3352.309-504.184l-1.876.949a21.6,21.6,0,0,1-8.749-4.153l.925-.851A7.922,7.922,0,0,1-3352.309-504.184Z",
  transform: "translate(3670.185 564.066)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_431",
  "data-name": "Path 431",
  d: "M-3115.979-562.787l1.1,1.088c-.489,3.022-1.008,6.01-5.29,5.089l-1.747-1.526C-3119.419-559.022-3118.184-561.525-3115.979-562.787Z",
  transform: "translate(3619.465 575.453)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_432",
  "data-name": "Path 432",
  d: "M-3180.921-563.873l1.082,1.068c.446,2.77-1.382,3.934-3.469,4.917l-1.874-2.4Z",
  transform: "translate(3632.778 575.681)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_433",
  "data-name": "Path 433",
  d: "M-3475.149-501.663c1.309-.159,2.558-.132,3.436,1.079Z",
  transform: "translate(3693.801 562.604)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_434",
  "data-name": "Path 434",
  d: "M-3121.157-558.417l5.29-5.089a2.947,2.947,0,0,0,.676-.182c.614.28.636,1.7,1.793.93,3.844-6.41,9.653-8.933,16.927-8.585,1.136.054,2.276.039,3.414.057,5.2,1.83,8.8,5.478,11.535,10.111,1.189.456,1.064-.5,1.229-1.146.28-.521.622-.9,1.273-.538a27,27,0,0,1,11.494,16.864,24.8,24.8,0,0,1,.009,10.169,12.3,12.3,0,0,1-3.956,6.932c-2.68,2.392-3.736,2.325-5.856-.5a23.064,23.064,0,0,1-4.361-10.991c-1.5.85-1.537,1.029-.875,4.293,1.393,4.364,2.781,8.7,7.719,10.5,1.879.685-.122,1.5-.081,2.265-3.24,2.013-6.261,4.506-10.338,4.677-.423.018-.873.253-1.259.163-2.437-.563-4.768-1.084-7,.842a2.9,2.9,0,0,1-2.817-.167c-2.4-2.26-4.088-.549-5.92.731a21.191,21.191,0,0,1-13.271-4.928,15.053,15.053,0,0,0,6.541-10.493c.824-2.4-.542-4.753-.2-6.785-.071.865.314,2.2-.757,3.206a20.35,20.35,0,0,1-3.5,9.512c-1.542,2.108-2.457,2.319-4.611.779a19.256,19.256,0,0,1-7.576-11.032C-3127.719-544.74-3126.515-552.021-3121.157-558.417Z",
  transform: "translate(3620.45 577.26)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_435",
  "data-name": "Path 435",
  d: "M-3182.808-559.779c-.01-2.462,2.415-3.206,3.469-4.917a2.006,2.006,0,0,0,.681-.293c.907-.5,1.691,1.007,2.619.161a17.432,17.432,0,0,1,11.145-7.876c1.13-.024,2.266.013,3.39-.081,7.326-.6,12.508,2.618,16.009,8.892.341.609.757,1.177,1.138,1.764.977.28,1.449.056,1.048-1.045a3.313,3.313,0,0,0-.291-.766c-.091-.81.2-1.137,1.009-.786a28.215,28.215,0,0,1,5.569,4.555,2.7,2.7,0,0,1,.476,3.762c-5.078,8.621-4.878,17.384-.12,26.019,1.17,2.123.72,3.355-.881,4.744-4.129,3.58-8.641,6.052-14.358,5.3a4.093,4.093,0,0,1-2.978.618c-1.665-.111-3.371.437-4.992-.323a2.517,2.517,0,0,0-3.485.095,5.929,5.929,0,0,1-3.935,1.433,37.35,37.35,0,0,1-12.7-5.965c-.445-1.468.692-2.358,1.272-3.444,1.134-2.123,2.371-4.2,2.743-6.635,1.349-2.234,1.109-4.729.911-7.112C-3175.638-548.541-3177.664-554.844-3182.808-559.779Z",
  transform: "translate(3632.279 577.572)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_436",
  "data-name": "Path 436",
  d: "M-3146.937-507.058c.832-.047,1.707-.277,2.336.545q.656.984,1.309,1.969c-.623,1.32-1.266,2.656-3.1,2.242-1.645-.371-1.575-1.78-1.708-3.04A2.232,2.232,0,0,1-3146.937-507.058Z",
  transform: "translate(3624.975 563.739)",
  fill: "#2b2b2b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_437",
  "data-name": "Path 437",
  d: "M-3105.549-528.157a21.684,21.684,0,0,1,.08-5.564c1.891,2.024,2.119,4.679.878,9.144C-3104.766-525.809-3104.736-527.1-3105.549-528.157Z",
  transform: "translate(3616.05 569.336)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_438",
  "data-name": "Path 438",
  d: "M-3133.06-560.593a4.253,4.253,0,0,1,.476.647c.366.745.724,1.938.007,2.179-1.244.417-1.242-.962-1.531-1.78Z",
  transform: "translate(3622.03 574.991)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_439",
  "data-name": "Path 439",
  d: "M-3132.367-562.9l-1.009.786c-.577-.6-1.395-1.364-.337-1.99C-3133.093-564.476-3132.519-563.665-3132.367-562.9Z",
  transform: "translate(3622.055 575.75)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_440",
  "data-name": "Path 440",
  d: "M-3600.538-519.366c-4.067.726-7.627-.928-11.227-2.392l-3.3-2.392a13.258,13.258,0,0,0,6.94-10.455,2.612,2.612,0,0,0,.113-1.916c-.11-.314-.075-.685-.348-.94a3.121,3.121,0,0,1-.662.966,23.348,23.348,0,0,1-3.065,7.46c-2.051,2.983-2.882,3.157-5.76.8a20.257,20.257,0,0,1-6.712-10.175c-.4-1.362-.638-2.771-.951-4.159.017-1.431-.017-2.864.059-4.291.427-8.067,4.766-13.757,10.845-18.482,1.5,1.12.013,2.407.83,3.4,1.4-.541,1.345-1.975,1.845-3.058,4.829-8.762,17.049-10.3,25.139-5.96,2.674,2.863,5.551,5.573,7.053,9.323,1.044.505,1.07-.111.963-.874-.021-.954-1.067-1.7-.493-3.01,2.529,1.1,4.086,3.334,6.119,4.94,5.033,5.637,7.631,12.135,7.037,19.778a24.355,24.355,0,0,0,.057,2.541,15.164,15.164,0,0,1-4.2,7.731c-1.289,1.191-2.622,2.2-4.532,1.769-3.389-2.292-4.994-5.057-5.971-10.289.508,3.6,1.474,5.595,5.272,10.9l2.954,1.741c-4.842,3.8-9.324,7.657-16,5.513-1.181-.379-1.781.3-2.615.857-1.652,1.1-3.668,1.308-5.1-.019C-3598.229-521.887-3599.247-520.385-3600.538-519.366Z",
  transform: "translate(3725.443 577.664)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_441",
  "data-name": "Path 441",
  d: "M-3682.025-563.6c1.406-1.289,2.435-3.062,4.434-3.535,1.063.549.023,2,1.186,2.453a2.542,2.542,0,0,0,1.135-2.5c7.1-8.38,14.057-10.355,24.052-6.829a28.473,28.473,0,0,1,8.854,10.72c1.462-1.664-.517-2.818.4-4.178,1.794.6,3.033,2,4.367,3.206,3.368,3.039,3.206,3.007,1.24,6.994-2.653,5.382-3.847,11.019-2.007,16.972.124,2.965,1.438,5.52,2.867,8.006.723,1.259,1.026,2.354-.206,3.433-4.492,3.934-9.1,7.6-15.685,5.616a2.6,2.6,0,0,0-2.682.8c-1.359,1.158-3.378,1.321-4.409.426-2.3-2-3.83-.885-5.541.55-6.111.324-10.878-2.7-15.457-6.2.125-1.518,1.269-2.513,1.964-3.728,2.7-4.711,4.131-9.651,3.09-15.112C-3674.794-553.167-3677.86-558.628-3682.025-563.6Z",
  transform: "translate(3737.336 578.165)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_442",
  "data-name": "Path 442",
  d: "M-3604.627-528.448v-6.607l1.045.017a11.94,11.94,0,0,1-.148,8.48Q-3604.179-527.5-3604.627-528.448Z",
  transform: "translate(3721.048 569.617)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_443",
  "data-name": "Path 443",
  d: "M-3071.07-528.83a10.264,10.264,0,0,1-.163-8.045c1.395,1.291,1.042,2.569,1.038,3.752C-3071.24-531.846-3070.837-530.273-3071.07-528.83Z",
  transform: "translate(3608.956 570)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_444",
  "data-name": "Path 444",
  d: "M-3066.925-560.93-3068-559.9q-.459.572-.682-.128c-.073-.721-.941-1.647-.032-2.1C-3067.962-562.5-3067.357-561.608-3066.925-560.93Z",
  transform: "translate(3608.356 575.332)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_445",
  "data-name": "Path 445",
  d: "M-3068.766-559.442c.226.051.454.093.683.128a3.7,3.7,0,0,1,.122.4c.122.674.552,1.719-.156,1.905-1.036.274-1.17-.874-1.389-1.659Z",
  transform: "translate(3608.435 574.749)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_446",
  "data-name": "Path 446",
  d: "M-3355.275-517.406a48.542,48.542,0,0,1-9.7-4.055l-1.456-1.7c4.359-2.857,6.106-7.147,6.665-11.371-.047,2.463-1.318,5.288-2.954,7.885-.781,1.24-1.741,3.277-3.957,1.682-6.388-3.973-9.689-9.8-10.354-17.218a38.224,38.224,0,0,1,1.166-8.066c1.616-5.554,5.188-9.576,9.978-13.3.2,1.433.313,2.238.469,3.359,1.544-.85,1.732-2.275,2.191-3.518,4.232-7.178,14.444-9.958,23.99-5.974a42.444,42.444,0,0,1,6.266,6.752,1.68,1.68,0,0,0,1.949-.134,1.907,1.907,0,0,1,1.465.1c7.943,5.768,12.368,13.321,11.885,23.377a12.639,12.639,0,0,0,.141,1.709c-.658,2.914-1.554,5.727-3.677,7.953-1.376,1.444-2.8,2.849-5.088,2.4-4.33-2.2-5-6.5-5.983-9.8.323,3.624,2.765,7.044,5.267,10.435l2.684,1.739c-4.943,4.791-10.3,7.68-17.322,5.356a7.415,7.415,0,0,1-7,0C-3350.944-519.235-3352.557-516.794-3355.275-517.406Z",
  transform: "translate(3673.152 577.288)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_447",
  "data-name": "Path 447",
  d: "M-3432.489-559.757c-.34-1.453.46-2.4,1.426-3.3,1.716-1.593,2.178-1.431,3.143,1.206,1.164-.329,1.346-1.19,1.266-2.211a17.913,17.913,0,0,1,11.278-8.658c1-.037,2,0,2.992-.122,7.757-.933,13.188,2.523,17.087,8.954.506.835.761,1.876,1.773,2.418,1.4-1.088-.581-2.3.232-3.58,1.428.109,2.229,1.514,3.49,2.006a2.877,2.877,0,0,0,.246.348c3.577,3.8,3.487,3.763,1.424,8.482-2.152,4.921-3.113,10.025-1.561,15.353-.057,3.14,1.483,5.754,3.01,8.276,1.134,1.875.823,3.121-.731,4.393-4.354,3.562-8.781,6.9-14.944,4.968-1.167-.366-1.844.318-2.646.915a3.783,3.783,0,0,1-4.763.17c-2.111-1.733-3.343-.417-4.768.783-6.268.192-11.611-1.718-15.545-6.837,3.059-4.44,5.3-9.168,5.172-14.727a8.234,8.234,0,0,0-.763-4.174A22.187,22.187,0,0,0-3432.489-559.757Z",
  transform: "translate(3684.84 577.601)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_448",
  "data-name": "Path 448",
  d: "M-3363.965-516.906c1.855-.131,2.614-1.58,3.449-2.907a19.741,19.741,0,0,0,2.811-8.925,17.351,17.351,0,0,1,.861-4.462c1.351,6.215.716,11.993-3.842,16.883a3.132,3.132,0,0,1-3.034,1.215C-3364.351-515.628-3364.138-516.27-3363.965-516.906Z",
  transform: "translate(3670.44 569.226)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_449",
  "data-name": "Path 449",
  d: "M-3483.724-538.64a22,22,0,0,1-3.262,11.409c-.9,1.376-1.837,2.591-3.736,2.288a26.428,26.428,0,0,1-6.944-6.894c-1.87-4.824-3.23-9.705-2.488-14.994.993-7.074,4.845-12.155,10.251-16.232,1.273.843.443,2,1.278,2.6a2.24,2.24,0,0,0,1.247-2.385c7.068-8.47,13.967-10.425,24.164-6.849a39.138,39.138,0,0,1,6.082,5.991c.862.568,1.69.178,2.521-.092a27.147,27.147,0,0,1,12.847,17.138,13.7,13.7,0,0,0,.8,1.926c-.037,1.433-.128,2.868-.1,4.3a14.868,14.868,0,0,1-5.861,12.747c-2.892,2.366-4.5.081-5.786-1.889a22.9,22.9,0,0,1-3.211-7.116c.511,1.211,1.118,3.169,2.043,5.019,1.189,2.378,2.4,4.568,5.315,5.124a1.081,1.081,0,0,1,.877,1.587c-3.3,2.97-6.745,5.682-11.417,6.091-1.127.1-2.314.433-3.357-.112a2.587,2.587,0,0,0-3.448.427c-.513.524-1.3.49-1.939.747-2.252.906-3.87-2.332-5.966-.98a7.7,7.7,0,0,1-5.585,1.46,4.707,4.707,0,0,0-.849.018c-2.487-1.33-5.282-2.024-7.6-3.7-.449-.324-.948-.579-1.661-1.008,3.9-2.92,6.046-6.272,6.679-10.519C-3482.833-534.613-3481.371-536.9-3483.724-538.64Z",
  transform: "translate(3699.106 577.265)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_450",
  "data-name": "Path 450",
  d: "M-3436.135-517.552c-7.069-3.48-10.183-9.634-9.137-18.637a11.484,11.484,0,0,1,1.384,4.526,23.344,23.344,0,0,0,4.167,9.7c1.116,1.544,2.418,2.362,4.348,1.687C-3434.917-519.17-3434.914-518.19-3436.135-517.552Z",
  transform: "translate(3687.554 569.855)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_451",
  "data-name": "Path 451",
  d: "M-3724.8-520.456c-4.066.722-7.626-.915-11.22-2.4l-3.249-2.367a13.321,13.321,0,0,0,6.887-10.442c.546-2.084-.595-4.127-.191-5.737-.132.97.484,2.553-.721,3.81a23.7,23.7,0,0,1-3.062,7.446c-2.048,2.977-2.887,3.16-5.749.8a19.983,19.983,0,0,1-6.794-10.574c-.394-1.508-.635-3.056-.947-4.586-.151-7.533,2.057-14.111,7.8-19.254.746-.667,1.486-1.345,2.275-1.957a4.867,4.867,0,0,1,1.165-.492c1.25.917-.289,2.216.568,3.2,1.4-.553,1.353-1.986,1.85-3.079,4.705-8.612,16.806-10.369,25.139-5.961,2.677,2.86,5.555,5.567,7.052,9.319,1.04.514,1.064-.1.952-.859q-.218-.731-.434-1.462c-.171-.893.2-1.2,1.06-.981,5.894,4.237,10,9.684,11.7,16.862.777,3.274.155,6.555.433,9.82a15.714,15.714,0,0,1-4.234,7.729c-1.293,1.187-2.625,2.2-4.536,1.773-4.237-2.125-4.862-6.346-5.927-9.454.39,3.441,2.792,6.763,5.228,10.067l2.941,1.761c-4.849,3.783-9.325,7.644-16,5.487-1.177-.381-1.776.32-2.61.868-1.651,1.084-3.662,1.3-5.095-.029C-3722.494-522.98-3723.513-521.473-3724.8-520.456Z",
  transform: "translate(3751.611 577.892)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_452",
  "data-name": "Path 452",
  d: "M-3688.1-521.632c-2.373-.641-3.19-2.748-4.191-4.6a16.061,16.061,0,0,1-1.654-12.028c.873,5.9,2.615,11.426,6.544,16.018Z",
  transform: "translate(3739.952 570.292)",
  fill: "#303030"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_453",
  "data-name": "Path 453",
  d: "M-3542.895-518.442a29.922,29.922,0,0,1-12.848-6.987c.224-1.324,1.258-2.166,1.931-3.221,3.2-5.013,4.994-10.357,3.92-16.39a25.918,25.918,0,0,0-5.013-13.769c-2.44-3.556-2.5-3.517,1.591-5.593.626.389.388.982.363,1.526-.019.41-.131.849.4,1.173,1.217-.672,1.344-2,1.772-3.144,4.5-7.18,12.854-9.655,23.04-6.72a25.173,25.173,0,0,1,8.906,10.106c1.017.423,1.178-.081,1.015-.937-.021-.819-.875-1.471-.312-2.8a36.151,36.151,0,0,1,7.245,6.47c1.24,1.482.074,2.625-.489,3.883-3.736,8.348-3.693,16.547,1.03,24.543.122.9,1.262,1.663.212,2.706-4.784,4.754-9.824,8.86-17.272,7.257-1-.934-1.772.022-2.617.328-.868.314-1.543,1.268-2.646.787-1.087-.867-2.493-1.016-3.688-1.641C-3538.554-520.106-3540.216-517.9-3542.895-518.442Z",
  transform: "translate(3710.94 577.555)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_454",
  "data-name": "Path 454",
  d: "M-3563.862-520.535c-2.374-.64-3.207-2.739-4.187-4.6a17.041,17.041,0,0,1-1.792-12c1.005,5.875,2.752,11.4,6.677,15.992Z",
  transform: "translate(3713.814 570.055)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_455",
  "data-name": "Path 455",
  d: "M-3507.756-559.632a3.051,3.051,0,0,1,.446.7c.2.639.5,1.563-.334,1.723-.729.14-1.022-.76-1.127-1.481Z",
  transform: "translate(3700.876 574.789)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_456",
  "data-name": "Path 456",
  d: "M-3225.652-517.207c-4.054.692-7.625-.913-11.23-2.358-.833-.756-2.016-1.11-2.653-2.353a14.871,14.871,0,0,0,6.367-10.541,7.484,7.484,0,0,0-.012-3.787c-.081-.287.076-.688-.317-.865a2.941,2.941,0,0,1-.639,1.089,20.517,20.517,0,0,1-3.39,9.588c-1.73,2.458-2.434,2.639-4.844.913a19.866,19.866,0,0,1-7.311-10.3c-.4-1.217-.643-2.485-.958-3.731a32.313,32.313,0,0,1,.872-10.59c1.312-4.592,4.208-8.041,7.583-11.171,1.773-1.645,1.967-1.527,3.29,1.04a2.417,2.417,0,0,0,1.2-2.523c4.237-6.4,10.444-8.63,17.8-8.424,7.492.813,11.723,5.822,15.1,12.128,1.382-1.488-.547-2.8.3-4.3,7.864,5.1,12.489,11.967,13.2,21.292.129,1.7.082,3.416.116,5.126a17.864,17.864,0,0,1-5.246,9.376c-1.787,2.8-3.656,1.515-5.127-.154a17.719,17.719,0,0,1-4.308-8.2,17.01,17.01,0,0,0,5.889,9.537c.773.6,2.422.622,1.828,2.33-1.864,1.3-3.706,2.637-5.6,3.893a11.433,11.433,0,0,1-6.065,1.856c-2.821.066-5.661-.815-8.348.974a2.513,2.513,0,0,1-2.838-.317C-3222.871-519.76-3224.219-518.5-3225.652-517.207Z",
  transform: "translate(3646.57 577.23)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_457",
  "data-name": "Path 457",
  d: "M-3186.525-516.442c-.94-1.567-2.941-1.707-4.067-2.952a18.917,18.917,0,0,1-4.761-15.544c1.1.9,1.011,2.193,1.222,3.378a25.367,25.367,0,0,0,4.253,10.186c1.382,1.988,2.95,2.486,5.073,1.419A3.692,3.692,0,0,1-3186.525-516.442Z",
  transform: "translate(3634.952 569.592)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_458",
  "data-name": "Path 458",
  d: "M-3308.526-559.391a3.218,3.218,0,0,1,1.841-3.1c.6-.381,1.275-.734,1.657.328.2.546-.255,1.731.837,1.435.8-.215,1.053-1.244.921-2.163,3.947-6.292,9.647-8.984,17.038-8.707a14.655,14.655,0,0,1,11.028,4.861c.666.745,1.391,1.439,2.088,2.158a20.176,20.176,0,0,0,2.984,5.008c1.292-1.629-.73-2.807-.021-4.492a33.212,33.212,0,0,1,7.3,6.316,3.24,3.24,0,0,1,.427,3.911c-1.306,2.857-2.353,5.8-2.035,9.04a21.657,21.657,0,0,0,4.3,16.343c-1.792,1.612-3.536,3.281-5.386,4.826a18.32,18.32,0,0,1-12.655,4.52,1.983,1.983,0,0,0-3.024-.192,4.283,4.283,0,0,1-5.835.16c-1.862-1.4-2.835.26-4.069,1.075-5.159.576-9.52-1.365-13.569-4.3-1.2-.869-2.236-1.825-1.959-3.514,3.87-5.088,6.142-10.653,5.128-17.2A25.56,25.56,0,0,0-3308.526-559.391Z",
  transform: "translate(3658.738 577.312)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_459",
  "data-name": "Path 459",
  d: "M-3315.388-519.369c-2.366-.609-3.19-2.7-4.2-4.528a17.718,17.718,0,0,1-1.929-11.854c1.132,2.6,1.328,5.46,2.3,8.1a35.583,35.583,0,0,0,4.538,7.654Z",
  transform: "translate(3661.53 569.763)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_460",
  "data-name": "Path 460",
  d: "M-3341.09-506.023l7,0-.952,1.611C-3337.247-504.224-3339.561-503.655-3341.09-506.023Z",
  transform: "translate(3665.588 563.507)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_461",
  "data-name": "Path 461",
  d: "M-3229.716-528.119v-5.551c1.94,2.132,2.17,4.647.968,9.115A7.907,7.907,0,0,0-3229.716-528.119Z",
  transform: "translate(3642.15 569.325)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_462",
  "data-name": "Path 462",
  d: "M-3690.823-560.709a2.579,2.579,0,0,1,.452.676c.174.632.458,1.574-.339,1.709-.676.114-.958-.82-1.065-1.525Z",
  transform: "translate(3739.388 575.016)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_463",
  "data-name": "Path 463",
  d: "M-3690.291-564.111l-1.061.981c-.62-.587-1.343-1.365-.462-2.023C-3691.265-565.563-3690.614-564.766-3690.291-564.111Z",
  transform: "translate(3739.482 575.974)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_464",
  "data-name": "Path 464",
  d: "M-3318.836-559.915c.074,1.01.957,1.987.017,3.3a13.738,13.738,0,0,1-2.406-4.282l.916-.929C-3318.874-561.916-3319.294-560.577-3318.836-559.915Z",
  transform: "translate(3661.408 575.251)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_465",
  "data-name": "Path 465",
  d: "M-3318.592-560.027l-1.475-1.907c1.316-1.06,1.845.088,2.5.89Z",
  transform: "translate(3661.164 575.363)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_466",
  "data-name": "Path 466",
  d: "M-3728.884-529.543v-6.59l1.064.008a12.142,12.142,0,0,1-.153,8.508Q-3728.427-528.581-3728.884-529.543Z",
  transform: "translate(3747.197 569.844)",
  fill: "#303030"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_467",
  "data-name": "Path 467",
  d: "M-3110.387-560.739c-.142.978-.239,1.984-1.449,2.336-.84-1.039-.248-2.19-.344-3.266C-3111.186-562.124-3110.985-561.049-3110.387-560.739Z",
  transform: "translate(3617.439 575.241)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_468",
  "data-name": "Path 468",
  d: "M-3443.089-561.962c-.257,1.547,1.255,2.889.568,4.76-1.767-1.243-2.228-3.094-3.089-4.667C-3444.791-562.454-3443.981-563.313-3443.089-561.962Z",
  transform: "translate(3687.584 575.431)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_469",
  "data-name": "Path 469",
  d: "M-3174.932-562.836a5,5,0,0,1-1.876,3.364c-1.107-1.029-.027-2.507-.742-3.525C-3176.622-563.86-3175.795-563.077-3174.932-562.836Z",
  transform: "translate(3631.173 575.58)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_470",
  "data-name": "Path 470",
  d: "M-3479.34-530.831c-.127-1.1-.557-2.227.567-3.46a12.464,12.464,0,0,1,.323,9.565C-3478.663-526.773-3478.312-528.9-3479.34-530.831Z",
  transform: "translate(3694.722 569.456)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_471",
  "data-name": "Path 471",
  d: "M-3148.129-507.041l-1.164,1.716c-1.488-.3-3.192.5-4.469-.876A18.034,18.034,0,0,0-3148.129-507.041Z",
  transform: "translate(3626.166 563.721)",
  fill: "#fefefe"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_472",
  "data-name": "Path 472",
  d: "M-3566.577-559.629a2.628,2.628,0,0,1,.448.679c.173.633.457,1.575-.335,1.713-.679.118-.959-.816-1.075-1.518Z",
  transform: "translate(3713.243 574.788)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_473",
  "data-name": "Path 473",
  d: "M-3530.963-507.032a4.04,4.04,0,0,1,3.688,1.642l-2.573-.036Z",
  transform: "translate(3705.546 563.72)",
  fill: "#fefefe"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_474",
  "data-name": "Path 474",
  d: "M-3092.332-544.226c-.764-.139-1.163-.759-1.631-1.269-2.034-2.217-2.172-3.027-.838-4.7,1.4-1.754,3.12-2.183,4.832-1.207,1.884,1.075,2.171,2.19,1.255,4.881a10.15,10.15,0,0,1-1.061-.085c-1.248-.182-1.4.816-1.734,1.616A3.94,3.94,0,0,1-3092.332-544.226Z",
  transform: "translate(3613.942 573.164)",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_475",
  "data-name": "Path 475",
  d: "M-3099.921-550.839c-.926.05-1.4-.35-1.448-1.154a1.25,1.25,0,0,1,1.2-1.389,1.143,1.143,0,0,1,1.37,1.146C-3098.74-551.394-3099.374-551.087-3099.921-550.839Z",
  transform: "translate(3615.141 573.476)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_476",
  "data-name": "Path 476",
  d: "M-3080.509-553.649c-.18.753-.576,1.247-1.428,1.164a1,1,0,0,1-.917-1.165c.052-.741.451-1.306,1.351-1.173C-3080.831-554.724-3080.665-554.187-3080.509-553.649Z",
  transform: "translate(3611.245 573.781)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_477",
  "data-name": "Path 477",
  d: "M-3091.442-542.922c.009-.284.02-.568.031-.853.763-1.363,1.6-2.572,3.442-1.579l.147.138C-3088.307-543.311-3089.112-541.912-3091.442-542.922Z",
  transform: "translate(3613.051 571.861)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_478",
  "data-name": "Path 478",
  d: "M-3087.91-530.279c-.052.107-.077.257-.163.31a.333.333,0,0,1-.323-.024c-.209-.272-.118-.467.229-.494C-3088.087-530.493-3088-530.353-3087.91-530.279Z",
  transform: "translate(3612.434 568.656)",
  fill: "#c5c5c5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_479",
  "data-name": "Path 479",
  d: "M-3147.23-527.265c1.1,3.482,1.684,7.055,3.2,10.909A10.963,10.963,0,0,1-3147.23-527.265Z",
  transform: "translate(3624.859 567.977)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_480",
  "data-name": "Path 480",
  d: "M-3160.621-517.485a18.934,18.934,0,0,1,1.767-9.893C-3157.939-523.528-3159.063-520.464-3160.621-517.485Z",
  transform: "translate(3627.618 568.001)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_481",
  "data-name": "Path 481",
  d: "M-3160.183-550.949c-.935-2.2.457-3.394,2.022-4.388,2.24-1.424,3.494.486,4.95,1.631a1.725,1.725,0,0,1-.246,2.223c-1.23.969-2.718-.184-3.985.48A3.392,3.392,0,0,1-3160.183-550.949Z",
  transform: "translate(3627.581 573.992)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_482",
  "data-name": "Path 482",
  d: "M-3160.1-550.379l1.564-1.747c1.476.524,2.846,1.6,4.56.872l.847-1.881c.637,2.486-.058,4.823-1.694,5.817a2.079,2.079,0,0,1-2.369-.088A7.545,7.545,0,0,1-3160.1-550.379Z",
  transform: "translate(3627.501 573.422)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_483",
  "data-name": "Path 483",
  d: "M-3152.651-530.676c.96,3.5.955,3.5-.457,6.155A7.337,7.337,0,0,1-3152.651-530.676Z",
  transform: "translate(3626.129 568.695)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_484",
  "data-name": "Path 484",
  d: "M-3144.571-552.717c-.136.563-.4,1.086-1.02,1.134a1.01,1.01,0,0,1-1.191-1.236,1.085,1.085,0,0,1,1.158-.956C-3145.01-553.776-3144.676-553.319-3144.571-552.717Z",
  transform: "translate(3624.7 573.557)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_485",
  "data-name": "Path 485",
  d: "M-3165.345-552.892a.868.868,0,0,1,.9.669.861.861,0,0,1-.938,1.063.747.747,0,0,1-.716-.859A.905.905,0,0,1-3165.345-552.892Z",
  transform: "translate(3628.761 573.371)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_486",
  "data-name": "Path 486",
  d: "M-3593.936-548.82c-1.2-2.47.457-3.649,2.213-4.668,1.682-.978,3-.006,4.143,1.131,1.662,1.661,1.131,3.315-.189,4.9a2.364,2.364,0,0,1-1.026-.332c-1.17-1.715-2.635-1.435-4.182-.617A1.256,1.256,0,0,1-3593.936-548.82Z",
  transform: "translate(3718.884 573.581)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_487",
  "data-name": "Path 487",
  d: "M-3587.883-547.777l.223,1.455c-2.1,2.351-2.26,2.416-4.23.819a17.2,17.2,0,0,1-1.937-2.184l1.23-.074A4.155,4.155,0,0,1-3587.883-547.777Z",
  transform: "translate(3718.776 572.447)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_488",
  "data-name": "Path 488",
  d: "M-3597.693-553.777a1.238,1.238,0,0,1-1.392,1,1.07,1.07,0,0,1-.933-1.483,1.232,1.232,0,0,1,1.593-.881C-3597.8-555.009-3597.6-554.525-3597.693-553.777Z",
  transform: "translate(3720.091 573.852)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_489",
  "data-name": "Path 489",
  d: "M-3579.226-555.526a1.241,1.241,0,0,1-1.174,1.429,1.181,1.181,0,0,1-1.333-1.251,1.118,1.118,0,0,1,.97-1.169C-3579.938-556.713-3579.462-556.3-3579.226-555.526Z",
  transform: "translate(3716.231 574.144)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_490",
  "data-name": "Path 490",
  d: "M-3653.248-557.256a3.081,3.081,0,0,1,1.843,3.428c-.315,2.1-2.316,4.255-3.719,3.889-1.569-.408-2.574-1.655-3.552-2.85a2.024,2.024,0,0,1,.08-3,3.593,3.593,0,0,0,1.494.007c.673-.193,1.095-.779,1.692-1.107C-3654.735-557.3-3653.916-556.808-3653.248-557.256Z",
  transform: "translate(3732.554 574.289)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_491",
  "data-name": "Path 491",
  d: "M-3643.539-519.088a10.951,10.951,0,0,1-2.659-10.584C-3645.306-526.146-3644.729-522.536-3643.539-519.088Z",
  transform: "translate(3729.889 568.484)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_492",
  "data-name": "Path 492",
  d: "M-3652.094-527.124c-.751-1.916-.581-3.752.717-6.088C-3650.6-530.683-3650.711-528.872-3652.094-527.124Z",
  transform: "translate(3731.131 569.229)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_493",
  "data-name": "Path 493",
  d: "M-3657.43-554.931l-.977-1.084c1.369-2,2.956-3.2,5.348-1.465l-1.905,1.023A2.013,2.013,0,0,1-3657.43-554.931Z",
  transform: "translate(3732.366 574.512)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_494",
  "data-name": "Path 494",
  d: "M-3657.884-524.766c-.523,1.557-.222,3.385-1.86,4.626.1-1.6.116-3.219,1.18-4.644l.359-.685Z",
  transform: "translate(3732.647 567.6)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_495",
  "data-name": "Path 495",
  d: "M-3643.365-555.238c-.062.571-.211,1.117-.886,1.185a.913.913,0,0,1-1.115-.9.978.978,0,0,1,.887-1.155C-3643.877-556.158-3643.409-555.948-3643.365-555.238Z",
  transform: "translate(3729.622 574.048)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_496",
  "data-name": "Path 496",
  d: "M-3664.054-553.686c-.68-.139-.819-.621-.721-1.2a.884.884,0,0,1,1.164-.8,1.2,1.2,0,0,1,.571.972A.957.957,0,0,1-3664.054-553.686Z",
  transform: "translate(3733.712 573.969)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_497",
  "data-name": "Path 497",
  d: "M-3657.6-525.6l-.68-.018a6.238,6.238,0,0,1,.4-3.807C-3656.975-528.015-3657.37-526.8-3657.6-525.6Z",
  transform: "translate(3732.362 568.432)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_500",
  "data-name": "Path 500",
  d: "M-3349.22-552.241a1.281,1.281,0,0,1-1.5,1.133,1.076,1.076,0,0,1-.967-1.522,1.284,1.284,0,0,1,1.668-.911A1.1,1.1,0,0,1-3349.22-552.241Z",
  transform: "translate(3668.883 573.523)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_501",
  "data-name": "Path 501",
  d: "M-3330.987-553.995a1.188,1.188,0,0,1-1.177,1.4,1.046,1.046,0,0,1-1.134-.989,1.142,1.142,0,0,1,1.157-1.391A1.089,1.089,0,0,1-3330.987-553.995Z",
  transform: "translate(3663.951 573.81)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_502",
  "data-name": "Path 502",
  d: "M-3404.756-555.025c2.521,2.331,2.514,5.091-.015,6.935a2,2,0,0,1-1.562.471c-1.229-.2-4.039-2.707-4.193-3.956a3.237,3.237,0,0,1,2.343-3.574C-3407.06-554.595-3405.9-555.1-3404.756-555.025Z",
  transform: "translate(3680.207 573.845)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_503",
  "data-name": "Path 503",
  d: "M-3411.267-517.214a8.052,8.052,0,0,1-.11-1.447c.543-2.615,1.108-5.225,1.693-7.963C-3408.246-524.153-3408.715-521.2-3411.267-517.214Z",
  transform: "translate(3680.383 567.843)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_504",
  "data-name": "Path 504",
  d: "M-3394.764-517.743c-2.453-2.9-3.584-6.09-2.524-9.823Z",
  transform: "translate(3677.499 568.041)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_505",
  "data-name": "Path 505",
  d: "M-3402.732-530.99a8.125,8.125,0,0,1-.017,5.844A8.979,8.979,0,0,1-3402.732-530.99Z",
  transform: "translate(3678.666 568.761)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_506",
  "data-name": "Path 506",
  d: "M-3394.886-552.988c-.009.592-.23,1.066-.923,1.052a.752.752,0,0,1-.8-.753c-.02-.617.248-1.082.933-1.056C-3395.262-553.728-3394.861-553.556-3394.886-552.988Z",
  transform: "translate(3677.273 573.55)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_507",
  "data-name": "Path 507",
  d: "M-3404.123-555.18a2.622,2.622,0,0,1-3.428-.124A2.621,2.621,0,0,1-3404.123-555.18Z",
  transform: "translate(3679.575 574)",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_508",
  "data-name": "Path 508",
  d: "M-3414.414-552.095a.876.876,0,0,1-1.248.711c-.47-.133-.555-.6-.481-1.033a.893.893,0,0,1,1.248-.732C-3414.455-553.022-3414.381-552.54-3414.414-552.095Z",
  transform: "translate(3681.388 573.436)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_509",
  "data-name": "Path 509",
  d: "M-3461.809-548.114c-.086,1.95-2.1,4.385-3.527,4.264-1.515-.129-4.292-2.893-4.34-4.32-.057-1.709,2.162-3.828,4-3.818A4.235,4.235,0,0,1-3461.809-548.114Z",
  transform: "translate(3692.648 573.18)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_510",
  "data-name": "Path 510",
  d: "M-3473.863-553.328c.6.1,1.108.423,1.117,1.02a1.31,1.31,0,0,1-1.592,1.424c-.646-.056-.9-.576-.877-1.183C-3475.18-552.91-3474.612-553.228-3473.863-553.328Z",
  transform: "translate(3693.814 573.462)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_511",
  "data-name": "Path 511",
  d: "M-3454.609-553.742c-.044.767-.343,1.336-1.211,1.3a.986.986,0,0,1-1.032-1.036c.006-.751.324-1.358,1.2-1.321A1.09,1.09,0,0,1-3454.609-553.742Z",
  transform: "translate(3689.95 573.773)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_926",
  "data-name": "Group 926",
  transform: "matrix(0.995, 0.105, -0.105, 0.995, 222.003, 32.966)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_512",
  "data-name": "Path 512",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_552",
  "data-name": "Path 552",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.836 2.424)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_549",
  "data-name": "Path 549",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(4.871 1.219)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_553",
  "data-name": "Path 553",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_556",
  "data-name": "Path 556",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 10.963)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_566",
  "data-name": "Path 566",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.399 9.744)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_557",
  "data-name": "Path 557",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 12.181)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_561",
  "data-name": "Path 561",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_568",
  "data-name": "Path 568",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(10.398 17.408)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_562",
  "data-name": "Path 562",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_567",
  "data-name": "Path 567",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.179 13.4)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_563",
  "data-name": "Path 563",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 17.054)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_550",
  "data-name": "Path 550",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_551",
  "data-name": "Path 551",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(9.743 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_564",
  "data-name": "Path 564",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_554",
  "data-name": "Path 554",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_560",
  "data-name": "Path 560",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(0 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_565",
  "data-name": "Path 565",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.397 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_555",
  "data-name": "Path 555",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(6.09 8.527)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_558",
  "data-name": "Path 558",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 10.963)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_930",
  "data-name": "Group 930",
  transform: "matrix(0.995, 0.105, -0.105, 0.995, 320.463, 32.966)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_512-2",
  "data-name": "Path 512",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_552-2",
  "data-name": "Path 552",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.836 2.424)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_549-2",
  "data-name": "Path 549",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(4.871 1.219)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_553-2",
  "data-name": "Path 553",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_556-2",
  "data-name": "Path 556",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 10.963)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_566-2",
  "data-name": "Path 566",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.399 9.744)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_557-2",
  "data-name": "Path 557",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 12.181)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_561-2",
  "data-name": "Path 561",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_568-2",
  "data-name": "Path 568",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(10.398 17.408)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_562-2",
  "data-name": "Path 562",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_567-2",
  "data-name": "Path 567",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.179 13.4)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_563-2",
  "data-name": "Path 563",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 17.054)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_550-2",
  "data-name": "Path 550",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_551-2",
  "data-name": "Path 551",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(9.743 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_564-2",
  "data-name": "Path 564",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_554-2",
  "data-name": "Path 554",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_560-2",
  "data-name": "Path 560",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(0 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_565-2",
  "data-name": "Path 565",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.397 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_555-2",
  "data-name": "Path 555",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(6.09 8.527)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_558-2",
  "data-name": "Path 558",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 10.963)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_931",
  "data-name": "Group 931",
  transform: "matrix(0.995, 0.105, -0.105, 0.995, 419.971, 32.966)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_512-3",
  "data-name": "Path 512",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_552-3",
  "data-name": "Path 552",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.836 2.424)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_549-3",
  "data-name": "Path 549",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(4.871 1.219)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_553-3",
  "data-name": "Path 553",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_556-3",
  "data-name": "Path 556",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 10.963)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_566-3",
  "data-name": "Path 566",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.399 9.744)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_557-3",
  "data-name": "Path 557",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 12.181)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_561-3",
  "data-name": "Path 561",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_568-3",
  "data-name": "Path 568",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(10.398 17.408)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_562-3",
  "data-name": "Path 562",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_567-3",
  "data-name": "Path 567",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.179 13.4)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_563-3",
  "data-name": "Path 563",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 17.054)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_550-3",
  "data-name": "Path 550",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_551-3",
  "data-name": "Path 551",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(9.743 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_564-3",
  "data-name": "Path 564",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_554-3",
  "data-name": "Path 554",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_560-3",
  "data-name": "Path 560",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(0 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_565-3",
  "data-name": "Path 565",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.397 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_555-3",
  "data-name": "Path 555",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(6.09 8.527)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_558-3",
  "data-name": "Path 558",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 10.963)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_932",
  "data-name": "Group 932",
  transform: "matrix(0.995, 0.105, -0.105, 0.995, 517.383, 32.966)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_512-4",
  "data-name": "Path 512",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_552-4",
  "data-name": "Path 552",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.836 2.424)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_549-4",
  "data-name": "Path 549",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(4.871 1.219)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_553-4",
  "data-name": "Path 553",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_556-4",
  "data-name": "Path 556",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 10.963)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_566-4",
  "data-name": "Path 566",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.399 9.744)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_557-4",
  "data-name": "Path 557",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 12.181)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_561-4",
  "data-name": "Path 561",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_568-4",
  "data-name": "Path 568",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(10.398 17.408)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_562-4",
  "data-name": "Path 562",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_567-4",
  "data-name": "Path 567",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.179 13.4)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_563-4",
  "data-name": "Path 563",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 17.054)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_550-4",
  "data-name": "Path 550",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_551-4",
  "data-name": "Path 551",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(9.743 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_564-4",
  "data-name": "Path 564",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_554-4",
  "data-name": "Path 554",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_560-4",
  "data-name": "Path 560",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(0 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_565-4",
  "data-name": "Path 565",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.397 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_555-4",
  "data-name": "Path 555",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(6.09 8.527)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_558-4",
  "data-name": "Path 558",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 10.963)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_513",
  "data-name": "Path 513",
  d: "M-3718.178-549.91c-1.2-2.47.457-3.649,2.212-4.668,1.684-.977,3.006-.006,4.144,1.131,1.661,1.661,1.131,3.315-.189,4.9a2.363,2.363,0,0,1-1.026-.332c-1.17-1.715-2.635-1.435-4.182-.617A1.253,1.253,0,0,1-3718.178-549.91Z",
  transform: "translate(3745.03 573.81)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_514",
  "data-name": "Path 514",
  d: "M-3712.125-548.867l.222,1.455c-2.106,2.351-2.26,2.417-4.23.82a17.1,17.1,0,0,1-1.937-2.185l1.23-.074A4.155,4.155,0,0,1-3712.125-548.867Z",
  transform: "translate(3744.921 572.676)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_515",
  "data-name": "Path 515",
  d: "M-3723.355-553.847a1.062,1.062,0,0,1-.956-1.083c.009-1.018.665-1.431,1.623-1.3a.934.934,0,0,1,.784,1.2A1.307,1.307,0,0,1-3723.355-553.847Z",
  transform: "translate(3746.235 574.078)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_516",
  "data-name": "Path 516",
  d: "M-3704.844-555.154c-.75-.21-1.27-.685-1.113-1.485a1.192,1.192,0,0,1,1.551-.974,1.09,1.09,0,0,1,.927,1.192C-3703.516-555.576-3704.08-555.253-3704.844-555.154Z",
  transform: "translate(3742.378 574.373)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_519",
  "data-name": "Path 519",
  d: "M-3528.972-554.068a2.671,2.671,0,0,1,1.384,3.214,6.385,6.385,0,0,1-2.3,3.469,1.936,1.936,0,0,1-2.366-.121,7.155,7.155,0,0,1-2.827-3.049,5.731,5.731,0,0,1,.854-.79c1.542-.132,3.072-.283,3.61-2.126A2.593,2.593,0,0,1-3528.972-554.068Z",
  transform: "translate(3706.412 573.618)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_520",
  "data-name": "Path 520",
  d: "M-3522.287-526.523c.333,1.612.612,3.24,1.016,4.834.413,1.634.948,3.238,1.479,5.014C-3522.371-518.97-3523.147-521.5-3522.287-526.523Z",
  transform: "translate(3703.791 567.821)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_521",
  "data-name": "Path 521",
  d: "M-3536.525-517.677q.8-4.268,1.6-8.537A8.892,8.892,0,0,1-3536.525-517.677Z",
  transform: "translate(3706.717 567.756)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_522",
  "data-name": "Path 522",
  d: "M-3533.808-550.865l-1.269.058c.219-4.348,2.223-5.5,6.106-3.512l-1.073,1.046C-3530.6-551.373-3532.678-551.864-3533.808-550.865Z",
  transform: "translate(3706.412 573.869)",
  fill: "#4d4d4d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_523",
  "data-name": "Path 523",
  d: "M-3528.088-525.276a3.893,3.893,0,0,1-.126-3.607c.981.235.718,1.038.75,1.611A2.036,2.036,0,0,1-3528.088-525.276Z",
  transform: "translate(3705.048 568.318)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_524",
  "data-name": "Path 524",
  d: "M-3539.281-551.8a1.064,1.064,0,0,1-1.173.9c-.67-.054-.929-.583-.9-1.2.038-.719.6-.936,1.178-.906C-3539.51-552.979-3539.229-552.505-3539.281-551.8Z",
  transform: "translate(3707.732 573.396)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_525",
  "data-name": "Path 525",
  d: "M-3519.576-552.464c-.075.585-.328,1.057-.959,1.141-.824.109-1.323-.276-1.26-1.131a1.108,1.108,0,0,1,1.12-1.008A1.053,1.053,0,0,1-3519.576-552.464Z",
  transform: "translate(3703.618 573.491)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_526",
  "data-name": "Path 526",
  d: "M-3219.435-546.5c-1.55-1.925-.1-3.1,1.146-4.218a3.023,3.023,0,0,1,3.866-.509c1.708,1.047,2.806,2.356,1.973,4.512a2.289,2.289,0,0,1-1.656.2c-1.48-.883-2.854-.22-4.239.292A4.478,4.478,0,0,1-3219.435-546.5Z",
  transform: "translate(3640.128 573.123)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_527",
  "data-name": "Path 527",
  d: "M-3213.2-546.668l.932,1a7.472,7.472,0,0,1-.66,1.514c-1.677,2.3-2.42,2.4-4.666.54a16.343,16.343,0,0,1-1.659-1.84l1.236-.155A6.959,6.959,0,0,1-3213.2-546.668Z",
  transform: "translate(3639.95 572.072)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_528",
  "data-name": "Path 528",
  d: "M-3204.709-553.236a1.26,1.26,0,0,1-1.476,1.123c-.872-.118-1.094-.777-.951-1.518a1.123,1.123,0,0,1,1.192-.941A1.229,1.229,0,0,1-3204.709-553.236Z",
  transform: "translate(3637.407 573.725)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_529",
  "data-name": "Path 529",
  d: "M-3223.083-551.769c-.229.728-.639,1.242-1.48,1.2a.986.986,0,0,1-.934-1.169,1.164,1.164,0,0,1,1.409-1.174C-3223.413-552.839-3223.166-552.372-3223.083-551.769Z",
  transform: "translate(3641.263 573.376)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_532",
  "data-name": "Path 532",
  d: "M-3286.621-549.056c-1.606-1.7-.759-3.115.568-4.4a3.2,3.2,0,0,1,3.88-.82c1.8.9,2.953,2.216,2.306,4.429a3.238,3.238,0,0,1-2.669-.026,2.321,2.321,0,0,0-2.476.784A1.592,1.592,0,0,1-3286.621-549.056Z",
  transform: "translate(3654.31 573.735)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_533",
  "data-name": "Path 533",
  d: "M-3274.31-525.626l2.714,9.908c-3.126-2.643-3.207-6.218-3.809-9.63Z",
  transform: "translate(3651.766 567.633)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_534",
  "data-name": "Path 534",
  d: "M-3281.224-550.784l1.591,1.746c-2.242,4.57-3.114,4.673-6.755.79l.856-.9C-3284.137-549.8-3282.612-550.113-3281.224-550.784Z",
  transform: "translate(3654.076 572.927)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_535",
  "data-name": "Path 535",
  d: "M-3286.582-525.39c.87,3.124.745,6.091-1.529,8.719Q-3287.345-521.031-3286.582-525.39Z",
  transform: "translate(3654.439 567.583)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_536",
  "data-name": "Path 536",
  d: "M-3279.592-528.4a4.382,4.382,0,0,1,.149,3.922C-3280.672-525.677-3280.2-526.856-3279.592-528.4Z",
  transform: "translate(3652.777 568.216)",
  fill: "#fcc419"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_537",
  "data-name": "Path 537",
  d: "M-3271.705-551.589c-.068.561-.185,1.112-.883,1.167a.912.912,0,0,1-1.108-.9,1,1,0,0,1,.888-1.167A.914.914,0,0,1-3271.705-551.589Z",
  transform: "translate(3651.406 573.288)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_538",
  "data-name": "Path 538",
  d: "M-3291.277-551.516c-.04,1.12-.233,1.628-.958,1.607a.772.772,0,0,1-.815-.775c-.029-.64.225-1.113.935-1.083C-3291.69-551.749-3291.271-551.587-3291.277-551.516Z",
  transform: "translate(3655.479 573.134)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_539",
  "data-name": "Path 539",
  d: "M-3088.41-546.126c-1.278.242-1.976,1.746-3.441,1.579-.751-1.125-2.264-1.992-1.444-3.676a2.134,2.134,0,0,1,2.127-1.16C-3089.123-549.272-3088.788-547.671-3088.41-546.126Z",
  transform: "translate(3613.491 572.633)",
  fill: "#f8f9fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_540",
  "data-name": "Path 540",
  d: "M-3153.562-551.184c-.515,1.129-.984,2.52-2.515,2.272-1.627-.263-2.043-1.648-2.044-3.144C-3156.307-553.305-3154.8-552.962-3153.562-551.184Z",
  transform: "translate(3627.083 573.351)",
  fill: "#ececec"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_541",
  "data-name": "Path 541",
  d: "M-3587.573-548.311c-2.306,2.008-2.306,2.008-4.715.016-.347-1.833.623-2.71,2.279-2.744C-3588.293-551.074-3587.5-550.017-3587.573-548.311Z",
  transform: "translate(3718.466 572.981)",
  fill: "#eaeaea"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_542",
  "data-name": "Path 542",
  d: "M-3657.17-554.435a4.557,4.557,0,0,1,2.466-1.526,7.062,7.062,0,0,1,1.37.92c1.077,1.157.756,2.293-.32,3.223-1.2,1.034-2.067.156-2.749-.731A7.5,7.5,0,0,1-3657.17-554.435Z",
  transform: "translate(3732.105 574.016)",
  fill: "#ebebeb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_543",
  "data-name": "Path 543",
  d: "M-3403.9-551.275c-.129,1.2-.684,2.238-2.012,2.227a2.131,2.131,0,0,1-2.114-2.223c-.045-1.239.931-1.664,2-1.686A1.865,1.865,0,0,1-3403.9-551.275Z",
  transform: "translate(3679.675 573.384)",
  fill: "#e9e9e9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_544",
  "data-name": "Path 544",
  d: "M-3463.049-546.97c-.353,1.126-.877,2.241-2.289,1.93a2.27,2.27,0,0,1-1.89-2.481,1.846,1.846,0,0,1,2.118-1.655A1.959,1.959,0,0,1-3463.049-546.97Z",
  transform: "translate(3692.136 572.589)",
  fill: "#ededed"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_545",
  "data-name": "Path 545",
  d: "M-3711.816-549.4c-2.306,2.008-2.306,2.008-4.715.016-.346-1.833.624-2.71,2.28-2.744C-3712.536-552.164-3711.738-551.106-3711.816-549.4Z",
  transform: "translate(3744.613 573.21)",
  fill: "#eaeaea"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_546",
  "data-name": "Path 546",
  d: "M-3533.47-550.36c.094-2.617,1.844-2.645,3.764-2.408,1.007,1.3,1.257,2.62-.225,3.693C-3531.643-547.837-3532.42-549.56-3533.47-550.36Z",
  transform: "translate(3706.073 573.364)",
  fill: "#ececec"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_547",
  "data-name": "Path 547",
  d: "M-3212.875-547.132c-1.99,3-1.99,3-4.818,1.064C-3216.775-549.56-3215.829-549.77-3212.875-547.132Z",
  transform: "translate(3639.62 572.535)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_548",
  "data-name": "Path 548",
  d: "M-3281-550.972c-.766,3.745-1.208,3.913-4.308,1.635C-3284.177-552.06-3284.032-552.115-3281-550.972Z",
  transform: "translate(3653.848 573.114)",
  fill: "#f0f0f0"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_927",
  "data-name": "Group 927",
  transform: "matrix(0.995, 0.105, -0.105, 0.995, 123.543, 32.967)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_512-5",
  "data-name": "Path 512",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_552-5",
  "data-name": "Path 552",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.836 2.424)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_549-5",
  "data-name": "Path 549",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(4.871 1.219)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_553-5",
  "data-name": "Path 553",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_556-5",
  "data-name": "Path 556",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 10.963)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_566-5",
  "data-name": "Path 566",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.399 9.744)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_557-5",
  "data-name": "Path 557",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 12.181)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_561-5",
  "data-name": "Path 561",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_568-5",
  "data-name": "Path 568",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(10.398 17.408)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_562-5",
  "data-name": "Path 562",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_567-5",
  "data-name": "Path 567",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.179 13.4)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_563-5",
  "data-name": "Path 563",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 17.054)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_550-5",
  "data-name": "Path 550",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_551-5",
  "data-name": "Path 551",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(9.743 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_564-5",
  "data-name": "Path 564",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_554-5",
  "data-name": "Path 554",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_560-5",
  "data-name": "Path 560",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(0 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_565-5",
  "data-name": "Path 565",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.397 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_555-5",
  "data-name": "Path 555",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(6.09 8.527)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_558-5",
  "data-name": "Path 558",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 10.963)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_929",
  "data-name": "Group 929",
  transform: "matrix(0.995, 0.105, -0.105, 0.995, 25.083, 31.92)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_512-6",
  "data-name": "Path 512",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_552-6",
  "data-name": "Path 552",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.836 2.424)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_549-6",
  "data-name": "Path 549",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(4.871 1.219)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_553-6",
  "data-name": "Path 553",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_556-6",
  "data-name": "Path 556",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 10.963)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_566-6",
  "data-name": "Path 566",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.399 9.744)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_557-6",
  "data-name": "Path 557",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 12.181)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_561-6",
  "data-name": "Path 561",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_568-6",
  "data-name": "Path 568",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(10.398 17.408)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_562-6",
  "data-name": "Path 562",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(3.652 14.617)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_567-6",
  "data-name": "Path 567",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(12.179 13.4)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_563-6",
  "data-name": "Path 563",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(6.089 17.054)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_550-6",
  "data-name": "Path 550",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(1.217 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_551-6",
  "data-name": "Path 551",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(9.743 3.654)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_564-6",
  "data-name": "Path 564",
  d: "M0,.737C.142.264.386-.152.942.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.105,1,0,.737Z",
  transform: "translate(8.525 0)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_554-6",
  "data-name": "Path 554",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_560-6",
  "data-name": "Path 560",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(0 7.31)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_565-6",
  "data-name": "Path 565",
  d: "M1.253.737C1.111.264.867-.152.312.054.133.12-.03.564,0,.8c.069.471.359.9.919.69C1.1,1.429,1.148,1,1.253.737Z",
  transform: "translate(13.397 6.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_555-6",
  "data-name": "Path 555",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(6.09 8.527)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_558-6",
  "data-name": "Path 558",
  d: "M0,.737C.142.264.386-.152.941.054c.179.066.342.51.307.75-.069.471-.359.9-.919.69C.15,1.428.1,1,0,.737Z",
  transform: "translate(9.745 10.963)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_569",
  "data-name": "Path 569",
  d: "M-3593.936-548.82c-1.2-2.47.457-3.649,2.213-4.668,1.682-.978,3-.006,4.143,1.131,1.662,1.661,1.131,3.315-.189,4.9a2.364,2.364,0,0,1-1.026-.332c-1.17-1.715-2.635-1.435-4.182-.617A1.256,1.256,0,0,1-3593.936-548.82Z",
  transform: "translate(3915.804 576.722)",
  fill: "#353535"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_570",
  "data-name": "Path 570",
  d: "M-3587.883-547.777l.223,1.455c-2.1,2.351-2.26,2.416-4.23.819a17.2,17.2,0,0,1-1.937-2.184l1.23-.074A4.155,4.155,0,0,1-3587.883-547.777Z",
  transform: "translate(3915.696 575.589)",
  fill: "#3f3f3f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_571",
  "data-name": "Path 571",
  d: "M-3587.573-548.311c-2.306,2.008-2.306,2.008-4.715.016-.347-1.833.623-2.71,2.279-2.744C-3588.293-551.074-3587.5-550.017-3587.573-548.311Z",
  transform: "translate(3915.386 576.123)",
  fill: "#eaeaea"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_572",
  "data-name": "Path 572",
  d: "M0,4.19A66.951,66.951,0,0,1,12.121,1.135,126.833,126.833,0,0,1,27.234,0",
  transform: "translate(372.793 387.908)",
  fill: "none",
  stroke: "#353535",
  strokeWidth: 1
}));

var SvgMobileIllustration = function SvgMobileIllustration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 555.358,
    height: 266.92,
    viewBox: "0 0 555.358 266.92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileIllustration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile-illustration.88fa727b.svg";
export { ForwardRef as ReactComponent };